export default __webpack_public_path__ + "static/media/blank.ab17410b.png";